import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AuthenticationService} from "../../modules/auth/_services/authentication.service";
import {
  GAME_VENDOR_LINK,
  GAME_VENDORS_FIREKIRIN,
  GAME_VENDORS_GOLDENDRAGON, GAME_VENDORS_JUWA, GAME_VENDORS_PUMA,
  GAME_VENDORS_RIVER, GAME_VENDORS_SENET, GAME_VENDORS_ULTRAPANDA, GAME_VENDORS_VBLINK
} from "../../config/gameVendors";
import {GamesPlaygroundService} from "../../service/games-playground/games-playground.service";
import {MainTabsService} from "../../service/main-tabs.service";
import {CurrencyService} from "../../modules/currency/currency.service";
import {UserBalanceService} from "../../service/users/userBalance.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PROJECT_MESSAGES} from "../../config/project";
import {PopupComponent} from "../../shared/popup/popup.component";
import {LoaderService} from "../../service/loader.service";
import {GetSenetSessionResponseModel} from "../../models/providers/getSenetSessionResponse.model";
import {GamesProviderService} from "../../service/games/gamesProvider.service";
import {NavigationService} from "../../service/navigation.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  depositForm: FormGroup;
  redeemForm: FormGroup;

  moreThenAvailablePayout = false;
  moreThenAvailableRedeemPayout = false;

  GAME_VENDOR_LINK = GAME_VENDOR_LINK;
  GAME_VENDORS_RIVER = GAME_VENDORS_RIVER;
  GAME_VENDORS_GOLDENDRAGON = GAME_VENDORS_GOLDENDRAGON;
  GAME_VENDORS_FIREKIRIN = GAME_VENDORS_FIREKIRIN;
  GAME_VENDORS_PUMA = GAME_VENDORS_PUMA;
  GAME_VENDORS_JUWA = GAME_VENDORS_JUWA;
  GAME_VENDORS_VBLINK = GAME_VENDORS_VBLINK;
  GAME_VENDORS_ULTRAPANDA = GAME_VENDORS_ULTRAPANDA;
  GAME_VENDORS_SENET = GAME_VENDORS_SENET;

  copyButtonText = 'copy';

  @ViewChild('redeemAmount', {static: false}) redeemAmount: ElementRef;
  @ViewChild('depositAmount', {static: false}) depositAmount: ElementRef;
  constructor(private authenticationService: AuthenticationService,
              private mainTabsService: MainTabsService,
              private formBuilder: FormBuilder,
              private popupComponent: PopupComponent,
              private currencyService: CurrencyService,
              private loaderService: LoaderService,
              private userBalanceService: UserBalanceService,
              private gamesProviderService: GamesProviderService,
              private navigationService: NavigationService,
              private gamesPlaygroundService: GamesPlaygroundService) {

  }

  ngOnInit(): void {
    this.depositForm = this.formBuilder.group({
      amount: [null, Validators.required],
    });

    this.redeemForm = this.formBuilder.group({
      amount: [null, Validators.required],
    });

    this.mainTabsService.updateActiveTab.subscribe(val => {
      if (val !== 'deposit') {
        this.depositForm.reset();
      }
      if (val !== 'redeem') {
        this.redeemForm.reset();
      }
    });

    this.gamesPlaygroundService.onGamesUpdated.subscribe(val => {
      if (this.isRedeemTabActive() && this.isUserLogged()) {
        this.getGameBalanceRequest();
      }
    });
  }

  getGameBalanceLoaderState() {
    return this.userBalanceService.getGameBalanceLoaderState();
  }


  isUserLogged() {
    return !!this.authenticationService.getCurrentUser()
  }

  getLoginBtnText() {
    return this.authenticationService.activeLoginBtnText;
  }

  getGameName() {
    return this.gamesPlaygroundService.getSelectedProviderName();
  }

  getGameShortName() {
    return this.gamesPlaygroundService.getSelectedProviderShortName();
  }

  getGameId() {
    return this.gamesPlaygroundService.getSelectedProviderId();
  }

  getGameAccount() {
    return this.gamesPlaygroundService.getSelectedProviderAccount() ?
           this.gamesPlaygroundService.getSelectedProviderAccount() : this.isUserLogged() ? null : 'account';
  }

  getGamePin() {
    return this.gamesPlaygroundService.getSelectedProviderPin() ?
      this.gamesPlaygroundService.getSelectedProviderPin() : this.isUserLogged() ? null : '11-11-11-11-11';
  }

  getGameMobileId() {
    return this.gamesPlaygroundService.getSelectedProviderMobileId() ?
      this.gamesPlaygroundService.getSelectedProviderMobileId() : this.isUserLogged() ? null : 'MobileId';
  }

  getGamePassword() {
    return this.gamesPlaygroundService.getSelectedProviderPassword() ?
           this.gamesPlaygroundService.getSelectedProviderPassword() : this.isUserLogged() ? null : 'password';
  }

  getGameGDPassword() {
    return this.gamesPlaygroundService.getSelectedProviderGDPassword() ?
      this.gamesPlaygroundService.getSelectedProviderGDPassword() : this.isUserLogged() ? null : 'password';
  }

  showChangingPasswordText() {
    const gameShortName = this.gamesPlaygroundService.getSelectedProviderShortName();
    return gameShortName === this.GAME_VENDORS_FIREKIRIN ||
      gameShortName === this.GAME_VENDORS_GOLDENDRAGON ||
      gameShortName === this.GAME_VENDORS_PUMA ||
      gameShortName === this.GAME_VENDORS_JUWA ||
      gameShortName === this.GAME_VENDORS_VBLINK ||
      gameShortName === this.GAME_VENDORS_ULTRAPANDA;
  }

  isGameWithAccountAndPassword() {
    const gameShortName = this.gamesPlaygroundService.getSelectedProviderShortName();
    return gameShortName === this.GAME_VENDORS_FIREKIRIN ||
      gameShortName === this.GAME_VENDORS_PUMA ||
      gameShortName === this.GAME_VENDORS_JUWA ||
      gameShortName === this.GAME_VENDORS_VBLINK ||
      gameShortName === this.GAME_VENDORS_ULTRAPANDA;
  }

  copyToBuffer(needMessage?) {
    if (this.isUserLogged()) {
      if (needMessage) {
        const copyBtn = (document.getElementById('copyBtn') as HTMLButtonElement);
        copyBtn.disabled = true;
        this.copyButtonText = 'copied';
        setTimeout(() => {
          this.copyButtonText = 'copy';
          copyBtn.disabled = false;
        }, 2000);
      }
      const gameShortName = this.gamesPlaygroundService.getSelectedProviderShortName();
      let tempInput = document.createElement('input');
      tempInput.value = gameShortName === GAME_VENDORS_RIVER ?
                        this.getGamePin() : this.getGameAccount() ? this.getGameAccount() : this.getGameMobileId();
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
    }
  }

  isRiverProvider() {
    return this.gamesPlaygroundService.getSelectedProviderShortName() === this.GAME_VENDORS_RIVER;
  }

  isSenetProvider() {
    return this.gamesPlaygroundService.getSelectedProviderShortName() === this.GAME_VENDORS_SENET;
  }

  isGDProvider() {
    return this.gamesPlaygroundService.getSelectedProviderShortName() === this.GAME_VENDORS_GOLDENDRAGON;
  }

  onCloseTabs() {
    this.mainTabsService.resetActiveTab();
  }

  isDepositTabActive(): boolean {
    return this.mainTabsService.isDepositTabActive();
  }

  isRedeemTabActive(): boolean {
    return this.mainTabsService.isRedeemTabActive();
  }

  isLoginTabActive(): boolean {
    return this.mainTabsService.isLoginTabActive();
  }

  isNoActiveTab(): boolean {
    return this.mainTabsService.isNoTabsActive();
  }

  formatCurrency(amount): string {
    return this.currencyService.formatCurrency(amount);
  }

  getGameBalance() {
    return this.isUserLogged() ? this.userBalanceService.getGameBalance() : 1000;
  }

  getEntriesBalance() {
    return this.isUserLogged() ? this.userBalanceService.getEntries() : 333;
  }

  getWinningsBalance() {
    return this.isUserLogged() ? this.userBalanceService.getWinnings() : 999;
  }

  onRedeemAmountInput() {
    const available = +this.getGameBalance();
    const entered = Number.parseFloat(this.redeemForm.controls.amount.value);

    if (available < entered) {
      this.redeemForm.controls.amount.setValue(String(available));
      this.moreThenAvailableRedeemPayout = true;
    } else {
      this.moreThenAvailableRedeemPayout = false;
    }
  }

  onSubmitRedeem(btn) {
    btn.showLoader = true;
    const amount = +this.redeemForm.controls.amount.value;
    const providerId = this.getGameId();

    if (!amount) {
      this.popupComponent.showPopupError({text: PROJECT_MESSAGES.notAllFieldsAreFilled});
      btn.showLoader = false;
    } else {
      this.sendRedeem(providerId, amount, btn);
    }
  }

  sendRedeem(providerId, amount, btn){
    this.userBalanceService.redeem(providerId, amount).subscribe(data => {
        this.displayRedeemSubmitResult(data);
      },
      () => {
          btn.showLoader = false;
          this.loaderService.hideAndShowTryAgain();
        },
      () => {
          btn.showLoader = false;
          //this.loaderService.hide();
      }
    );
  }

  displayRedeemSubmitResult(data) {
    try {
      if (data.status) {
        this.popupComponent.showPopupSuccess({text: data.message});
        this.getGameBalanceRequest();
        this.getMainBalance();
        this.redeemForm.reset();
        this.depositForm.reset();
        this.moreThenAvailableRedeemPayout = false;
      } else {
        this.popupComponent.showPopupError({text: data.message});
      }
    } catch (e) {
      this.loaderService.hideAndShowTryAgain();
    }
  }

  getMainBalance(btn?) {
    this.userBalanceService.getBalance().subscribe(data => {
      this.userBalanceService.updateBalance(data.entries, data.spend);
    }, () => {
      if (btn) {
        btn.showLoader = false;
      }
      this.loaderService.hideAndShowTryAgain();
    }, () => {
      if (btn) {
        btn.showLoader = false;
      }
      this.loaderService.hide();
    });
  }

  getGameBalanceRequest() {
    this.userBalanceService.initGameBalanceRequest(this.getGameId());
  }

  onDepositPaymentTypeChanged() {
    this.onDepositAmountInput();
    this.depositAmount.nativeElement.focus();
  }

  onDepositAmountInput() {
    const available = +this.getDepositPaymentType();
    const entered = Number.parseFloat(this.depositForm.controls.amount.value);

    if (available < entered) {
      this.depositForm.controls.amount.setValue(String(available));
      this.moreThenAvailablePayout = true;
    } else {
      this.moreThenAvailablePayout = false;
    }
  }

  getDepositPaymentType() {
    return this.isPaymentTypeEntries() ? this.getEntriesBalance() : this.getWinningsBalance();
  }

  isPaymentTypeEntries(): boolean {
    const radio = document.querySelector('input[name="paymentType"]:checked');
    return radio.id === 'entries';
  }

  onSubmitDepositForm(btn) {
    btn.showLoader = true;
    const amount = +this.depositForm.controls.amount.value;
    if (!amount) {
      const message = 'Please, fill all required fields.';
      this.popupComponent.showPopupError({text: message});
      btn.showLoader = false;
    } else {
      if (this.isPaymentTypeEntries()) {
        this.onSubmitDepositFormEntries(amount, btn)
      } else {
        this.submitWithdrawFormRequest(amount, btn)
      }
    }
  }

  onSubmitDepositFormEntries(amount, btn) {
    const providerId = this.getGameId();
    this.userBalanceService.increaseBalance(amount, providerId).subscribe(data => {
      this.displayDepositSubmitResult(data);
    }, (error) => {
      btn.showLoader = false;
      this.loaderService.hideAndShowTryAgain();
    }, () => {
      btn.showLoader = false;
      //this.loaderService.hide();
    });
  }

  displayDepositSubmitResult(data) {
    try {
      if(data.status){
        this.popupComponent.showPopupSuccess({text: data.message});
        this.depositForm.reset();
        this.moreThenAvailablePayout = false;
        this.getMainBalance();
        //this.userBalanceService.initGameBalanceRequest(this.getGameId());
      }else{
        this.popupComponent.showPopupError({text: data.message});
      }
    } catch (e) {
      this.loaderService.hideAndShowTryAgain();
    }
  }

  submitWithdrawFormRequest(amount, btn) {
    const providerId = this.getGameId();
    this.userBalanceService.withdraw(providerId, amount).subscribe(data => {
        this.displayDepositSubmitResult(data);
      },
      () => {
        btn.showLoader = false;
        this.loaderService.hideAndShowTryAgain()
      },
      () => {
        btn.showLoader = false;
        //this.loaderService.hide();
      }
    );
  }

  showLoginPage() {
    if (this.isUserLogged()) {
      this.authenticationService.logout();
    } else {
      this.mainTabsService.makeLoginTabActive();
    }
  }

  onGameSweep() {
    const game = this.getGameShortName();
    if(game == GAME_VENDORS_SENET){
      this.getSenetSession();
    } else {
      if (this.isUserLogged()) {
        this.copyToBuffer();
      }
      this.goToSweep();
    }
  }

  getSenetSession() {
    this.gamesProviderService.getSenetSession().subscribe(data => {
      this.setSenetSession(data);
    }, () => {
      this.loaderService.hideAndShowTryAgain();
    }, () => {
      setTimeout(() => {
        this.loaderService.hide();
      }, 500);
    });
  }

  setSenetSession(data: GetSenetSessionResponseModel): void {
    try {
      if (data.status) {
        const url = data.sessionLink;
        this.goToSweep(url);
      } else {
        this.popupComponent.showPopupError({text: data.message});
      }
    } catch (e) {
      this.loaderService.hideAndShowTryAgain();
    }
  }

  goToSweep(senetLink?) {
    const gameShortName = this.getGameShortName();
    let link;
    switch (gameShortName) {
      case GAME_VENDORS_RIVER:
        link = this.GAME_VENDOR_LINK.river;
        break;
      case GAME_VENDORS_FIREKIRIN:
        link = this.GAME_VENDOR_LINK.firekirin;
        break;
      case GAME_VENDORS_PUMA:
        link = this.GAME_VENDOR_LINK.puma;
        break;
      case GAME_VENDORS_JUWA:
        link = this.GAME_VENDOR_LINK.juwa;
        break;
      case GAME_VENDORS_VBLINK:
        link = this.GAME_VENDOR_LINK.vblink;
        break;
      case GAME_VENDORS_ULTRAPANDA:
        link = this.GAME_VENDOR_LINK.ultrapanda;
        break;
      case GAME_VENDORS_SENET:
        link = senetLink;
        break;
      default:
        link = this.GAME_VENDOR_LINK.goldenDragon;
        break;
    }
    // const link = this.riverView ? this.GAME_VENDOR_LINK.river : this.accountPasswordView ? this.GAME_VENDOR_LINK.firekirin : this.GAME_VENDOR_LINK.goldenDragon;
    setTimeout(() => {
      var win = window.open(link, '_blank');
      win.focus();
    }, 250);
  }

  goToSupport() {
    this.navigationService.goToSupport();
  }
}
